import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconFilter: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="filter">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 12a3.501 3.501 0 0 0 3.449-2.9H21.85V7.9H11.199a3.501 3.501 0 0 0-6.898 0H2.65v1.2H4.3A3.501 3.501 0 0 0 7.75 12Zm2.3-3.5a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6 0ZM20.199 16.1a3.501 3.501 0 0 1-6.898 0H2.65v-1.2H13.3a3.501 3.501 0 0 1 6.898 0h1.651v1.2h-1.651Zm-1.149-.6a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6 0Z"
    />
  </Icon>
);
